import { render, staticRenderFns } from "./OrdersHelpModal.vue?vue&type=template&id=254dac9f&scoped=true&"
import script from "./OrdersHelpModal.vue?vue&type=script&lang=ts&"
export * from "./OrdersHelpModal.vue?vue&type=script&lang=ts&"
import style0 from "./OrdersHelpModal.vue?vue&type=style&index=0&id=254dac9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254dac9f",
  null
  
)

export default component.exports